"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Client = void 0;
var Client = /** @class */ (function () {
    function Client(data) {
        this.id = data.id;
        this.firstname = data.firstname;
        this.lastname = data.lastname;
        this.title = data.title;
        this.address = data.address;
        this.country = data.country;
        this.phone1 = data.phone1;
        this.phone2 = data.phone2;
        this.job = data.job;
        this.email = data.email;
        this.zip = data.zip;
        this.ifu = data.ifu;
        this.rccm = data.rccm;
        this.created_at = data.created_at;
    }
    Object.defineProperty(Client.prototype, "summer", {
        get: function () {
            return "".concat(this.title, "(").concat(this.ifu, "), ").concat(this.firstname, ", ").concat(this.lastname);
        },
        enumerable: false,
        configurable: true
    });
    Client.prototype.toJson = function () {
        return __assign({}, this);
    };
    return Client;
}());
exports.Client = Client;
